module.exports = __webpack_public_path__ + "r-v3/img/cam_off.40a4884e.svg";